import { Layout as AntLayout } from 'antd'
import type { ComponentProps } from 'react'

type AntLayoutProps = ComponentProps<typeof AntLayout>

export interface AppLayoutProps extends AntLayoutProps {}

export const AppLayout = (props: AppLayoutProps) => <AntLayout {...props} />

export const AppLayoutHeader = AntLayout.Header
export const AppLayoutSider = AntLayout.Sider
export const AppLayoutContent = AntLayout.Content
export const AppLayoutFooter = AntLayout.Footer
